import React, { Fragment } from 'react'
import { contactChore } from '../../../../../models/graphqlTypes'
import { useTranslation } from '../../../../../common/hooks'
import { IconButton, Stack, Typography } from '@mui/material'
import { ContactType } from './patientContacts.types'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'
import { BoxWithLabel } from '../../../../../common/components/BoxWithLabel'

interface ViewPatientContactsProps {
  contacts: contactChore[]
  contactType: ContactType
  openContactModal: () => void
}

export const ViewPatientContacts: React.FC<
  React.PropsWithChildren<ViewPatientContactsProps>
> = ({ contacts, contactType, openContactModal }) => {
  const { t } = useTranslation()

  return (
    <>
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Typography variant="body2" fontWeight="700">
          {t(`patients:contactTypes.${contactType}`)}
        </Typography>

        <IconButton onClick={openContactModal} sx={{ p: 0 }}>
          <ModeEditOutlineOutlinedIcon color="primary" fontSize="large" />
        </IconButton>
      </Stack>

      {contacts.map((contact) => (
        <Fragment key={contact.id}>
          <BoxWithLabel
            label={t('patients:contactName')}
            size="small"
            extraStyle={{ paddingBlock: '2px' }}
          >
            <Typography variant="body2">
              {t('common:formattedName', {
                firstName: contact.firstName,
                lastName: contact.lastName,
              })}
            </Typography>
          </BoxWithLabel>

          <BoxWithLabel
            label={t('patients:contactPhone')}
            size="small"
            extraStyle={{ paddingBlock: '2px' }}
          >
            <Typography variant="body2">{contact.phone}</Typography>
          </BoxWithLabel>
        </Fragment>
      ))}
    </>
  )
}
